import { createContext, Dispatch, DispatchWithoutAction, SetStateAction } from 'react';
import type { Alert } from '@/components/Alert';

type FeedbackContext = {
  toggleProcessing: DispatchWithoutAction;
  showToast: ({ status, title, message }: Alert) => void;
  heightNotice: number;
  setHeightNotice: Dispatch<SetStateAction<number>>;
};

const FeedbackContext = createContext<FeedbackContext>({
  toggleProcessing: () => {},
  showToast: () => {},
  heightNotice: 0,
  setHeightNotice: () => {},
});

export default FeedbackContext;
